import * as React from 'react'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ContentBack } from './ContentBack/ContentBack'
import { ContentFront } from './ContentFront/ContentFront'
import {
  flipCard,
  selectUpcomingFollowUps,
} from '@user/store/dashboard/widgets/upcomingFollowUps/slice'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { WidgetWrapper } from '../../Widget/WidgetWrapper'

export const UpcomingFollowUps: FC = () => {
  const dispatch = useAppDispatch()
  const { showFront } = useSelector(selectUpcomingFollowUps)

  const handleFlipCard = useCallback(() => {
    dispatch(flipCard())
  }, [dispatch])

  return (
    <WidgetWrapper
      testIdPrefix="upcoming-follow-ups-widget"
      contentFront={<ContentFront />}
      contentBack={<ContentBack />}
      title="Upcoming Follow-Ups"
      settingsAction={handleFlipCard}
      showFront={showFront}
    />
  )
}

UpcomingFollowUps.displayName = 'UpcomingFollowUps'
